module.exports = __webpack_public_path__ + "img/events.8ffc4e59.svg";